import axios from "axios";
import { BASE_URL } from "./baseUrl";

export const getOffer = async(data) => {
    const res = await axios.post(`${BASE_URL}/calc/offer`, {
      data: data,
    });
    return res;
};
